import { stack } from "styled-system/patterns";

export const chartTooltipStyles = stack({
  bg: "background.primary",
  borderWidth: "100",
  rounded: "200",
  borderColor: "border.secondary",
  textStyle: "body.md",
  p: "12",
  gap: "8",
});
